import React from 'react'
import { Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

export const FormMicContainer = (props) => {

    const {
        handleInputChange, name_container,
    } = props;

    return (
        <Form className="pt-3" role="form" >
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre del contenedor <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="name_container"
                            value={name_container}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

        </Form>
    )
}
